import { sendNotification } from '../hooks/useNotification';
import { WorkerActionResult, WorkerInput } from './utils';
// @ts-ignore - Vite worker import
import WebWorker from './worker.web.js?worker';

/**
 * BackgroundWorker for web platform
 * Uses actual Web Worker for background processing
 */
class BackgroundWorker {
  counter = 0;
  worker: Worker;

  constructor() {
    try {
      this.worker = new WebWorker();
    } catch (error) {
      this.worker = undefined as unknown as Worker;
      return;
    }

    this.worker.onmessage = this.receive.bind(this);
    this.worker.onerror = (error: ErrorEvent) => {
      console.error('[BackgroundWorker] Worker error:', error.message);
    };
  }

  send({ action, data, priority }: WorkerInput) {
    const requestId = `${Date.now()}${++this.counter}`;
    const workerInput: WorkerInput = { requestId, action, data, priority };
    return this.worker.postMessage(JSON.stringify(workerInput));
  }

  async receive(event: WorkerActionResult | { data: WorkerActionResult }) {
    const data = (event as { data: WorkerActionResult }).data as string;
    try {
      const result = (data && JSON.parse(data)) as any;

      // Handle log messages from worker (silently ignore for production)
      if (result.type === 'LOG') {
        return;
      }

      if (result.status === 'ERROR') {
        sendNotification({
          error: true,
          message: result.data?.errorMessage || result.message || 'Print Error',
        });
      }
    } catch (err) {
      console.error('[BackgroundWorker] Failed to parse worker response:', err);
    }
  }
}

export default BackgroundWorker;
